var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 0.625H1.5625C1.31395 0.625289 1.07566 0.724154 0.899907 0.899907C0.724154 1.07566 0.625289 1.31395 0.625 1.5625V7.8125H1.875V1.875H18.125V18.125H1.875V11.875H0.625V18.4375C0.625289 18.6861 0.724154 18.9243 0.899907 19.1001C1.07566 19.2758 1.31395 19.3747 1.5625 19.375H18.4375C18.6861 19.3747 18.9243 19.2758 19.1001 19.1001C19.2758 18.9243 19.3747 18.6861 19.375 18.4375V1.5625C19.3747 1.31395 19.2758 1.07566 19.1001 0.899907C18.9243 0.724154 18.6861 0.625289 18.4375 0.625Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17879 14.1917L9.06266 15.0755L14.3214 9.81682L9.06266 4.55811L8.17879 5.44193L11.9287 9.19186H0.625V10.4419H11.9286L8.17879 14.1917Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.d4008e920c23586bffcd955ed4a6e608.svg";
export { ForwardRef as ReactComponent };